// extracted by mini-css-extract-plugin
export default {"red":"#ff3449","adminAttestationsWrapper":"Attestations_adminAttestationsWrapper__q-uQO"};